import { useMemo } from "react";
import { useFormik } from "formik";
import {
  CreateDynamicSchema,
  RequiredField,
  ConditionalField,
  OPTION_MSG,
  REQUIRED_MSG,
} from "../schema/formik";
import { IMisdeliveryInvestigation } from "../models";

export const misdeliveryInvestigationInitialValues: IMisdeliveryInvestigation =
  {
    osdType: undefined,
    osdNumber: undefined,
    username: undefined,
    wasPickUpCompleted: undefined,
    wasPickUpRescheduled: undefined,
    pickupNumber: undefined,
    reasonUnableToPickUp: undefined,
    isFreightInOsdBay: undefined,
    didFreightMoveOnOd400: undefined,
    od400ProNumber: undefined,
    isFreightLabeledForAnotherCustomer: undefined,
    wasDeliveredToWrongAddress: undefined,
    doesAs400AddressMatchBol: undefined,
    doesBolShowSlc: undefined,
    bolNumber: undefined,
    shipperNumber: undefined,
    poNumber: undefined,
    isFreightLabeledShowingMsdAddress: undefined,
    misdeliveryAddress1: undefined,
    misdeliveryAddress2: undefined,
    misdeliveryCity: undefined,
    misdeliveryState: undefined,
    misdeliveryZip: undefined,
    isTrueSaiaError: undefined,
    driverName: undefined,
    dockWorkerName: undefined,
  };

const validationConfig = [
  RequiredField("wasPickUpCompleted", OPTION_MSG),
  ConditionalField(
    "wasPickUpRescheduled",
    "wasPickUpCompleted",
    "N",
    true,
    OPTION_MSG,
  ),
  ConditionalField(
    "pickupNumber",
    "wasPickUpRescheduled",
    "Y",
    true,
    REQUIRED_MSG,
  ),
  ConditionalField(
    "reasonUnableToPickUp",
    "wasPickUpRescheduled",
    "N",
    true,
    REQUIRED_MSG,
    "string",
    false,
    50,
    "Reason Unable To Pick Up must be at most 50 characters",
  ),
  RequiredField("isFreightInOsdBay", OPTION_MSG),
  ConditionalField(
    "didFreightMoveOnOd400",
    "isFreightInOsdBay",
    "N",
    true,
    OPTION_MSG,
  ),
  ConditionalField(
    "od400ProNumber",
    "didFreightMoveOnOd400",
  ),
  RequiredField("isFreightLabeledForAnotherCustomer", OPTION_MSG),
  RequiredField("wasDeliveredToWrongAddress", OPTION_MSG),
  RequiredField("doesAs400AddressMatchBol", OPTION_MSG),
  RequiredField("doesBolShowSlc", OPTION_MSG),
  RequiredField("isFreightLabeledShowingMsdAddress", OPTION_MSG),
  ConditionalField( "misdeliveryAddress1","isFreightLabeledShowingMsdAddress", "N"),
  {
    max: 30,
    maxMessage: "Misdelivery Address 2 must be at most 30 characters",
    name: "misdeliveryAddress2",
    type: "string",
  },
  ConditionalField( "misdeliveryCity","isFreightLabeledShowingMsdAddress", "N"),
  ConditionalField( "misdeliveryZip","isFreightLabeledShowingMsdAddress", "N"),
  ConditionalField( "misdeliveryState","isFreightLabeledShowingMsdAddress", "N"),
  RequiredField("isTrueSaiaError", OPTION_MSG),
  RequiredField(
    "driverName",
    REQUIRED_MSG,
    true,
    "string",
    false,
    30,
    "Driver Name must be at most 30 characters",
  ),
  RequiredField(
    "dockWorkerName",
    REQUIRED_MSG,
    true,
    "string",
    false,
    30,
    "Dockworker Name must be at most 30 characters",
  ),
  RequiredField(
    "bolNumber",
    "",
    false,
    "string",
    false,
    20,
    "BOL Number must be at most 20 characters",
  ),
  RequiredField(
    "shipperNumber",
    "",
    false,
    "string",
    false,
    20,
    "Shipper Number must be at most 20 characters",
  ),
  RequiredField(
    "poNumber",
    "",
    false,
    "string",
    false,
    20,
    "PO Number must be at most 20 characters",
  ),
];

export const misdeliveryInvestigationValidationSchema =
  CreateDynamicSchema(validationConfig);

export const useMisdeliveryInvestigationForm = (
  initialData?: Partial<IMisdeliveryInvestigation>,
) => {
  const initialValues = useMemo(
    () => ({
      ...misdeliveryInvestigationInitialValues,
      ...initialData,
    }),
    [initialData],
  );

  const formik = useFormik<IMisdeliveryInvestigation>({
    initialValues,
    enableReinitialize: true,
    validationSchema: misdeliveryInvestigationValidationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (_v) => {console.info("Form submitted");},
  });

  return { formik };
};
